<sim-basic-material-dialog
	(closeClicked)="close({action: 'cancel'})"
	[finished]="finished"
	[headerText]="(T.PDU_CONFIG_DIALOG_HEADER | translate) + data.powerDistributionUnit.name"
	[headerIcon]="{fontIcon: 'fa-outlet', fontSet: 'fad'}"
	[matDialogData]="data"
	[rect]="rect"
	[smallHeader]="true"
>
	<ng-container dialogContent>
		<div class="row">
			<div class="formRow">
				<mat-form-field color="accent">
					<mat-label>
						{{ "Username" | translate }}
					</mat-label>
					<input [(ngModel)]="data.powerDistributionUnit.username" matInput type="text" />
				</mat-form-field>
				<button
					(click)="updateAllPDUs('Username', data.powerDistributionUnit.username)"
					[appBusy]="updateAllPDUsTask"
					[busyOption]="'disable-class'"
					class="btn btn-default btn-80"
					color="accent"
					mat-stroked-button
					type="button"
				>
					{{ T.PDU_UPDATE_ALL | translate }}
					<i class="fad fa-sync-alt"></i>
				</button>
			</div>

			<div class="formRow">
				<mat-form-field color="accent">
					<mat-label>
						{{ T.GLOBAL_TEXT_PASSWORD | translate }}
					</mat-label>
					<input
						[(ngModel)]="data.powerDistributionUnit.password"
						[type]="hidePassword ? 'password' : 'text'"
						matInput
						matInput
					/>
					<button
						(click)="hidePassword = !hidePassword"
						[attr.aria-label]="'Hide password'"
						[attr.aria-pressed]="hidePassword"
						mat-icon-button
						matSuffix
					>
						@if (hidePassword) {
							<mat-icon fontIcon="fa-eye-slash" fontSet="fas" inline style="font-size: 0.8em" />
						}
						@if (!hidePassword) {
							<mat-icon fontIcon="fa-eye" fontSet="far" inline style="font-size: 0.8em" />
						}
					</button>
				</mat-form-field>
				<button
					(click)="updateAllPDUs('Password', data.powerDistributionUnit.password)"
					[appBusy]="updateAllPDUsTask"
					[busyOption]="'disabled'"
					class="btn btn-default btn-80"
					color="accent"
					mat-stroked-button
					type="button"
				>
					{{ T.PDU_UPDATE_ALL | translate }}
					<i class="fad fa-sync-alt"></i>
				</button>
			</div>
		</div>
	</ng-container>

	<ng-container actions>
		<sim-button
			(onClick)="close({action: 'cancel'})"
			[icon]="{fontSet: 'fal', fontIcon: 'fa-times'}"
			[label]="T.BUTTON_CANCEL"
			[color]="'warn'"
		/>

		<sim-button
			(onClick)="
				close({
					action: 'ok',
					powerDistributionUnit: data.powerDistributionUnit,
				})
			"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="T.BUTTON_OK"
			[color]="'accent'"
		/>
	</ng-container>
</sim-basic-material-dialog>
